<template>
    <div>
        <MenuMember/>
        <RetailerList/>
    </div>
</template>

<script>
import MenuMember from '@/components/admin/member/menumember/MenuMember.vue'
import RetailerList from '@/components/admin/member/retailer/RetailerList.vue'

export default {
    name:'retailer',
    components:{
        MenuMember,
        RetailerList,
    }
}
</script>